import {
  PestsRevision,
  PestsRounding,
} from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

export const addPestsRoundingControl =
  withFoodControlPointInstance<PestsRounding>();

export const updatePestsRoundingControl =
  withFoodControlPointInstance<PestsRounding>(true);

export async function getPestsRoundingControlByInstanceId(instanceId: string) {
  return axios
    .get<PestsRounding>("/PestRoundings/getpestroundingbyinstanceid", {
      params: { id: instanceId },
    })
    .then((res) => res.data);
}

export const addPestsRevisionControl =
  withFoodControlPointInstance<PestsRevision>();

export const updatePestsRevisionControl =
  withFoodControlPointInstance<PestsRevision>(true);

export async function getPestsRevisionControlByInstanceId(instanceId: string) {
  return axios
    .get<PestsRevision>("/PestsRevisions/getpestsrevisionbyinstanceid", {
      params: { id: instanceId },
    })
    .then((res) => res.data);
}
